import { storefrontRoutePaths } from '@/router/paths';

/**
 * Resolves a platform `action_url` (relative or absolute; the platform builds
 * absolute storefront links) to an in-app path. Account-portal paths are
 * accepted from any host; other paths only when relative or same-origin.
 * Returns null when the link cannot be followed in-app.
 */
export function toInAppPath(actionUrl: string | null): string | null {
  if (actionUrl === null || actionUrl === '') return null;
  const origin = window.location.origin;
  let parsed: URL;
  try {
    parsed = new URL(actionUrl, origin);
  } catch {
    return null;
  }
  const accountRoot = storefrontRoutePaths.account.root;
  const isAccountPath =
    parsed.pathname === accountRoot || parsed.pathname.startsWith(`${accountRoot}/`);
  if (!isAccountPath && parsed.origin !== origin) return null;
  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
